// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ErwartungswerteListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useSearchErwartungswerte(): (
  aufgabeId: string,
  unteraufgabeId: string
) => Promise<ErwartungswerteListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, unteraufgabeId) =>
      (await getAPI()).erwartungswerte.searchErwartungswerte({
        aufgabeId,
        unteraufgabeId,
      }),
    [getAPI]
  );
}
